
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { RedoOutlined, UndoOutlined, QuestionOutlined } from '@ant-design/icons-vue'
import { GlobalDataProps } from '../../store/index'
export default defineComponent({
  components: {
    RedoOutlined,
    UndoOutlined,
    QuestionOutlined
  },
  setup() {
    const store = useStore<GlobalDataProps>()
    const histories = computed(() => store.state.editor.histories)
    const historyIndex = computed(() => store.state.editor.historyIndex)
    const undoIsDisabled = computed<boolean>(() => store.getters.checkUndoDisable)
    const redoIsDisabled = computed<boolean>(() => store.getters.checkRedoDisable)

    const visible = ref(false)

    const undoHistory = () => {
      store.commit('undo')
    }
    const redoHistory = () => {
      store.commit('redo')
    }
    return {
      visible,
      histories,
      undoHistory,
      redoHistory,
      historyIndex,
      undoIsDisabled,
      redoIsDisabled
    }
  }
})
